<template>
	<div v-if="user">
		<inertia-head title="Profile" />
		<div class="bg-trc-main">
			<div class="bg-black-25">
				<div class="content text-center">
					<div class="py-0">
						<h1 class="fw-bold text-white mb-2">Manage Profile</h1>
						<h2 class="h4 fw-normal text-white-75 fs-sm"></h2>
					</div>
				</div>
			</div>
		</div>
		<div class="content">
			<div class="row">
				<div class="col-md-8">
					<div class="block block-rounded row g-0 overflow-hidden h-100">
						<ul
							class="nav nav-tabs nav-tabs-block flex-md-column col-md-4 rounded-0"
							role="tablist"
						>
							<li class="nav-item d-md-flex flex-md-column">
								<button
									class="nav-link fs-sm text-md-start rounded-0 active"
									id="btabs-vertical-profile-tab"
									data-bs-toggle="tab"
									data-bs-target="#btabs-vertical-profile"
									role="tab"
									aria-controls="btabs-vertical-profile"
									aria-selected="true"
								>
									<i
										class="fa fa-fw fa-user-circle opacity-50 me-1 d-none d-sm-inline-block"
									></i>
									Profile <i v-if="user.edit!==1" class="fa fa-exclamation-circle text-danger"></i>
								</button>
							</li>
							<li class="nav-item d-md-flex flex-md-column">
								<button
									class="nav-link fs-sm text-md-start rounded-0"
									id="btabs-vertical-facebook-tab"
									data-bs-toggle="tab"
									data-bs-target="#btabs-vertical-facebook"
									role="tab"
									aria-controls="btabs-vertical-facebook"
									aria-selected="true"
								>
									<i
										class="fa fa-fw fa-link opacity-50 me-1 d-none d-sm-inline-block"
									></i>
									Facebook Profile <i v-if="user.c_fblink===null" class="fa fa-exclamation-circle text-danger"></i>
								</button>
							</li>
							<li class="nav-item d-md-flex flex-md-column">
								<button
									class="nav-link fs-sm text-md-start rounded-0"
									id="btabs-vertical-contact-tab"
									data-bs-toggle="tab"
									data-bs-target="#btabs-vertical-contact"
									role="tab"
									aria-controls="btabs-vertical-contact"
									aria-selected="false"
								>
									<i
										class="fa fa-fw fa-address-book opacity-50 me-1 d-none d-sm-inline-block"
									></i>
									Contact <i v-if="user.mobile===null || user.mobile===''" class="fa fa-exclamation-circle text-danger"></i>
								</button>
							</li>
							<!-- <li class="nav-item d-md-flex flex-md-column">
								<button
									class="nav-link fs-sm text-md-start rounded-0"
									id="btabs-vertical-insurance-tab"
									data-bs-toggle="tab"
									data-bs-target="#btabs-vertical-insurance"
									role="tab"
									aria-controls="btabs-vertical-insurance"
									aria-selected="false"
								>
									<i
										class="fa fa-fw fa-user-shield opacity-50 me-1 d-none d-sm-inline-block"
									></i>
									Insurance
								</button>
							</li>
							<li class="nav-item d-md-flex flex-md-column">
								<button
									class="nav-link fs-sm text-md-start rounded-0"
									id="btabs-vertical-affiliate-tab"
									data-bs-toggle="tab"
									data-bs-target="#btabs-vertical-affiliate"
									role="tab"
									aria-controls="btabs-vertical-affiliate"
									aria-selected="false"
								>
									<i
										class="fa fa-fw fa-sitemap opacity-50 me-1 d-none d-sm-inline-block"
									></i>
									Affiliates
								</button>
							</li> -->
							<!-- <li class="nav-item d-md-flex flex-md-column">
								<button
									class="nav-link fs-sm text-md-start rounded-0"
									id="btabs-vertical-browser-session-tab"
									data-bs-toggle="tab"
									data-bs-target="#btabs-vertical-browser-session"
									role="tab"
									aria-controls="btabs-vertical-browser-session"
									aria-selected="false"
								>
									<i
										class="fa fa-fw fa-globe opacity-50 me-1 d-none d-sm-inline-block"
									></i>
									Browser Sessions
								</button>
							</li> -->
						</ul>
						<div class="tab-content col-md-8">
							<div
								class="block-content tab-pane active"
								id="btabs-vertical-profile"
								role="tabpanel"
								aria-labelledby="btabs-vertical-profile-tab"
							>
								<h4 class="fw-semibold">Personal Information</h4>
								<form autocomplete="off">
									<div class="form-floating mb-4">
										<input
											v-model="user.fname"
											type="text"
											class="form-control"
											id="fname"
											placeholder="Enter your first name"
											readonly
										/>
										<label class="form-label" for="fname">First Name</label>
									</div>
									<div class="form-floating mb-4">
										<input
											v-model="user.lname"
											type="text"
											class="form-control"
											id="lname"
											placeholder="Enter your last name"
											readonly
										/>
										<label class="form-label" for="lname">Last Name</label>
									</div>

									<div class="form-floating mb-4">
										<flat-pickr
											v-model="form.bday"
											:config="{
												altInput: true,
												altFormat: 'M j, Y',
												dateFormat: 'Y-m-d',
											}"
											id="bday"
											class="form-control"
											placeholder="Enter bday date"
											:class="
												errors.bday
													? 'flatpickr-input is-invalid border-danger'
													: 'flatpickr-input'
											"
										/>
										<label class="form-label" for="birthdate">Birthdate</label>
										<div v-if="errors.bday" class="invalid-feedback">
											{{ errors.bday }}
										</div>
									</div>
									<div class="form-floating mb-4">
										<select
											v-model="form.gender"
											class="form-control"
											placeholder="Select your gender"
										>
											<option disabled selected>Select Gender</option>
											<option value="Male">Male</option>
											<option value="Female">Female</option>
										</select>
										<label class="form-label" for="gender">Gender</label>
									</div>

									<div class="form-floating mb-4">
										<input type="text" v-model="form.address" id="address" name="address" class="form-control" placeholder="Home Address"/>
										<label class="form-label">Home Address</label>
										<div v-if="form.errors.address && form.address==''" class="show-error">
											<i class="fa fa-exclamation-circle"></i>
											{{ form.errors.address }}
										</div>
									</div>

									<div class="form-floating mb-4">
										<div class="form-floating mb-4">
											<select v-model="form.country" id="country" name="country" class="form-select">
												<option v-for="country in countries" :value="country.country">{{country.country}}</option>
											</select>
											<label class="form-label">Country</label>
											<div v-if="form.errors.country && form.country==''" class="show-error">
												<i class="fa fa-exclamation-circle"></i>
												{{ form.errors.country }}
											</div>
										</div>
										<div v-if="form.country=='Philippines'">
											<div class="form-floating mb-4">
												<select v-model="form.province" id="province" name="province" class="form-select">
													<option v-for="province in provinces" :value="province.prov_code+'|'+province.prov_desc">{{province.prov_desc}}</option>
												</select>
												<label class="form-label">Province</label>
												<div v-if="form.errors.province && form.province==''" class="show-error">
													<i class="fa fa-exclamation-circle"></i>
													{{ form.errors.province }}
												</div>
											</div>
											<div class="form-floating mb-4">
												<select v-model="form.city" id="city" name="city" class="form-select">
													<option v-for="city in cities[(form.province).split('|')[0]]" :value="city.citymun_desc">{{city.citymun_desc}}</option>
												</select>
												<label class="form-label">City</label>
												<div v-if="form.errors.city && form.city==''" class="show-error">
													<i class="fa fa-exclamation-circle"></i>
													{{ form.errors.city }}
												</div>
											</div>
										</div>	
									</div>

									<div class="form-group text-center">
										<button v-if="user.edit!=1" @click="updateProfile" :disabled="!form.isDirty || form.processing" type="button" class="btn btn-success"><i class="fa fa-save"></i> Update</button>
									</div>

									<div v-if="sponsor!=null" class="form-group text-center fw-semibold">
										You were referred by {{sponsor}}
									</div>
								</form>
							</div>
							<div
								class="block-content tab-pane"
								id="btabs-vertical-facebook"
								role="tabpanel"
								aria-labelledby="btabs-vertical-facebook-tab"
							>
								<h4 class="fw-semibold">Facebook Profile Link</h4>
								<p>Type in your facebook profile link so we can add you to the private Truly Rich Club FB Group that is launching soon!</p>
								<div class="form-floating mb-4">
									<input
										v-model="formFbLink.c_fblink"
										type="text"
										class="form-control"
										id="c_fblink"
										placeholder="Enter your facebook profile link"
									/>
									<label class="form-label" for="c_fblink">Facebook Profile Link</label>
								</div>
								<div class="form-group text-center">
									<button @click="updateFbProfileLink" :disabled="!formFbLink.isDirty || formFbLink.processing" type="button" class="btn btn-success"><i class="fa fa-save"></i> Update</button>
								</div>
							</div>
							<div
								class="block-content tab-pane"
								id="btabs-vertical-contact"
								role="tabpanel"
								aria-labelledby="btabs-vertical-contact-tab"
							>
								<h4 class="fw-semibold">Contact Information</h4>
								<form action="">
									<div class="form-floating mb-4">
										<input
											v-model="user.email"
											type="text"
											class="form-control"
											id="email"
											placeholder="Enter your email"
											readonly
										/>
										<label class="form-label" for="email">Email address</label>
									</div>
									<div class="mb-4">
										<!-- <vue-tel-input
											v-model="form.mobile"
											:value="form.mobile"
											:defaultCountry="form.country_code"
											mode="international"
											class="form-control"
										/> -->
										<vue-tel-input
											@input="onInput"
											@countryChanged="onCountryChange"
											v-model="form.mobile"
											:value="form.mobile"
											class="form-control"
											:class="{ 'is-invalid': form.errors.mobile }"
											:input-options="{
												placeholder: 'Enter mobile number',
											}"
											:defaultCountry="form.country_code"
											mode="international"
										/>
									</div>

									<!-- <div v-if="otp_details.country_code=='PH' && otp_details.send_otp_date!=null && otp_details.is_otp_confirm==0" class="block block-rounded shadow">
										<div class="block-content block-content-full">
											<div class="form-floating mb-4">
												<input v-model="formVerify.mobile_otp" type="text" id="otp" name="otp" class="form-control" placeholder="Please enter your OTP Number" />
												<label class="form-label">Please enter your OTP Number</label>
												<div v-if="formVerify.errors.mobile_otp && formVerify.mobile_otp==''" class="show-error">
													<i class="fa fa-exclamation-circle"></i>
													{{ formVerify.errors.mobile_otp }}
												</div>
											</div>
										</div>
										<div class="block-footer pb-3 text-center">
											<button @click="verifyOTP" type="button" class="btn btn-success px-5">
												<span v-if="!formVerify.processing"><i class="fa fa-check-circle me-1"></i>VERIFY OTP</span>
												<span v-else>
													<div class="spinner-border spinner-border-sm text-dark" role="status" >
														<span class="sr-only mr-1">Please wait...</span>
													</div>
													<span class="mx-2">Please wait...</span>
												</span>
											</button>
											<div v-if="seconds_remain>0" class="mt-4">
												<p class="m-0 fs-sm text-danger">Please wait 5 minutes before you can re-send the OTP</p>
												<p class="my-3 text-danger text-center">
													<label class="fw-bold">TIME</label>
													<div>
														<span class="border border-danger px-2 fw-bold">0{{minutes}}</span>
														<span class="fw-bold mx-1">:</span>
														<span class="border border-danger px-2 fw-bold">{{seconds}}</span>
													</div>
												</p>
											</div>
											<div v-else class="mt-4">
												Forgot your OTP Number? 
												<button @click="sendOTP" class="btn text-info m-0 p-0">
													<span v-if="!form.processing">Resend Here</span>
													<span v-else>
														<div class="spinner-border spinner-border-sm text-white" role="status" >
															<span class="sr-only mr-1">Please wait...</span>
														</div>
														<span class="mx-2">Please wait...</span>
													</span>
												</button>
												|<button type="button" @click="toggleModal" class="btn btn-sm text-info">Edit Mobile</button>
											</div>
										</div>
									</div> -->

									<div class="form-group text-center">
										<button @click="updateMobile" :disabled="!form.isDirty || form.processing" type="button" class="btn btn-success"><i class="fa fa-save"></i> Update</button>
									</div>
								</form>
							</div>
							<div
								class="block-content tab-pane"
								id="btabs-vertical-insurance"
								role="tabpanel"
								aria-labelledby="btabs-vertical-insurance-tab"
							>
								<h4 class="fw-semibold">Beneficiaries</h4>
								<!-- <div class="row g-sm mb-3">
									<div class="col-12 mb-2">
										<div
											id="beneficiary-accordion"
											role="tablist"
											aria-multiselectable="true"
										>
											<div
												v-for="(beneficiary, index) in beneficiaries"
												:key="beneficiary.id"
												class="block block-bordered block-rounded mb-1"
											>
												<div
													class="block-header"
													role="tab"
													:id="'beneficiary-accordion_h' + index"
												>
													<a
														class="fw-semibold text-body-color-dark"
														data-bs-toggle="collapse"
														:href="'#beneficiary_b' + index"
														aria-expanded="true"
														:aria-controls="'beneficiary_b' + index"
													>
														Beneficiary {{ index + 1 }}
													</a>
												</div>
												<div
													:id="'beneficiary_b' + index"
													class="collapse"
													role="tabpanel"
													:aria-labelledby="'beneficiary-accordion_h' + index"
													data-bs-parent="#beneficiary-accordion"
												>
													<div class="block-content border-top">
														<table
															class="table table-striped table-borderless table-vcenter"
														>
															<tbody class="fs-sm">
																<tr>
																	<th>First Name</th>
																	<td>{{ beneficiary.fname }}</td>
																</tr>
																<tr>
																	<th>Last Name</th>
																	<td>{{ beneficiary.lname }}</td>
																</tr>
																<tr>
																	<th>Birthday</th>
																	<td>{{ beneficiary.birthday }}</td>
																</tr>
																<tr>
																	<th>Relationship</th>
																	<td>{{ beneficiary.relationship }}</td>
																</tr>
															</tbody>
															<tfoot>
																<tr class="text-center">
																	<td>
																		<inertia-link
																			:href="
																				'/post/delete-beneficiary/' +
																				beneficiary.id
																			"
																			class="btn btn-alt-danger btn-sm w-100"
																			method="delete"
																			as="button"
																			:only="['beneficiaries']"
																			preserve-state
																			preserve-scroll
																		>
																			<i class="fa fa-trash me-2"></i>
																			Delete
																		</inertia-link>
																	</td>
																	<td>
																		<button
																			@click="toggleModal('edit')"
																			class="btn btn-alt-info btn-sm w-100"
																		>
																			<i class="fa fa-user-edit me-2"></i>
																			Edit
																		</button>
																	</td>
																</tr>
															</tfoot>
														</table>
													</div>
												</div>
											</div>
										</div>
										<div v-if="beneficiaries.length < 4" class="text-center">
											<button
												@click="toggleModal('add')"
												type="submit"
												class="btn btn-lg btn-alt-primary w-100 py-3 fw-semibold"
											>
												<i class="fa fa-user-plus"></i>
												Add Beneficiary
											</button>
											<small class="fw-semibold">
												You can add up to four(4) beneficiaries.
											</small>
										</div>
									</div>
								</div> -->
							</div>
							<div
								class="block-content tab-pane"
								id="btabs-vertical-affiliate"
								role="tabpanel"
								aria-labelledby="btabs-vertical-affiliate-tab"
							>
								<h4 class="fw-semibold">Affiliate Information</h4>
								<!-- contact -->
							</div>
							<div
								class="block-content tab-pane"
								id="btabs-vertical-browser-session"
								role="tabpanel"
								aria-labelledby="btabs-vertical-browser-session-tab"
							>
								<h4 class="fw-semibold">
									Browser Sessions
									<inertia-link
										href="/member/profile"
										:only="['browserSessions', 'flash']"
										preserve-state
									>
										<i class="si si-reload text-muted float-end"></i>
									</inertia-link>
								</h4>
								<table
									class="table table-striped table-borderless table-vcenter"
								>
									<tbody>
										<tr
											v-for="session in browserSessions"
											:key="session.id"
											class="fw-semibold"
										>
											<td class="text-center">
												<i
													:class="
														'text-muted fa fa-' +
														(session.isDesktop ? 'desktop' : 'mobile-alt')
													"
												></i>
												<div class="clearfix"></div>
												<span class="fw-normal fs-xs">
													{{ session.device }}
												</span>
											</td>
											<td class="fs-xs">
												{{ session.platform + ' - ' + session.browser }}
												<div class="clearfix"></div>
												<small class="fw-light">
													{{ session.ipAddress }}
												</small>
												<span v-if="session.isCurrent">
													<span class="text-flat-light mx-1">
														This device
													</span>
												</span>
												<small v-if="!session.isCurrent" class="fw-light">
													- Last active
													{{ session.lastActivity }}
												</small>
											</td>
											<td class="text-center fs-xs">
												<inertia-link
													v-if="!session.isCurrent"
													class="fw-normal text-pulse btn fs-xs"
													:href="route('member.post.logout-browser-session')"
													:only="['browserSessions', 'flash']"
													:data="{ id: session.id }"
													method="post"
													as="button"
													preserve-state
												>
													Logout
												</inertia-link>
											</td>
										</tr>
									</tbody>
									<tfoot v-if="browserSessions.length > 1">
										<tr>
											<td colspan="3">
												<hr />
												<inertia-link
													class="btn btn-secondary btn-sm float-end"
													href="post/logout-browser-session"
													:only="['browserSessions']"
													:data="{
														id: 'allOtherSession',
													}"
													as="button"
													method="post"
													preserve-state
												>
													Logout other browser sessions
												</inertia-link>
											</td>
										</tr>
									</tfoot>
								</table>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-4">
					<div class="block block-rounded block-themed text-center h-100">
						<div
							class="block-content block-content-full block-sticky-options pt-4"
						>
							<a class="img-link" href="javascript:void(0)"
								:set="img_bg=$page.props.rank_prefix=='S' ? '0891b2' 
										: ($page.props.rank_prefix=='G' ? 'FEC10D'
										: ($page.props.rank_prefix=='GC' ? 'dfa705'
										: ($page.props.rank_prefix=='D' ? 'd97706'
										: ($page.props.rank_prefix=='P'	? '22844b'
										: ($page.props.rank_prefix=='PC'? '36b3a0'
										: ($page.props.rank_prefix=='PF'? '32a67f'
										: ($page.props.rank_prefix=='B' ? '8f55f2'
										: '343a40'
										)))))))
									"
							>
								<img
									class="img-avatar img-avatar-thumb user-avatar img-avatar96"
									:src="
										tempAvatarUrl !== null
											? tempAvatarUrl
											: user.avatar === 'default-avatar.png'
											? 'https://ui-avatars.com/api/?size=128&background='+img_bg+'&color=fff&font-size=0.5&bold=true&length=1&name=' +
											  user.full_name
											: '/avatar/' + user.avatar
									"
									alt="avatar"
								/>
							</a>
						</div>
						<div
							class="block-content block-content-full block-content-sm bg-dark"
						>
							<div class="fw-semibold text-white mb-1">
								{{ user.full_name }}
							</div>
							<div class="fs-sm text-white-75">{{ user.current_rank }} {{ user.add_alias }}</div>
						</div>
						<div class="block-content block-content-full text-start">
							<div class="mb-4">
								<label class="form-label" for="avatar">Change Photo</label>
								<input
									@change="onFileChange"
									class="form-control"
									:class="{ 'is-invalid': $page.props.errors.avatar }"
									type="file"
									id="avatar"
									accept="image/*"
								/>
								<div v-if="$page.props.errors.avatar" class="invalid-feedback">
									{{ $page.props.errors.avatar }}
								</div>
							</div>
						</div>
						<div class="block-content block-content-full text-center">
							<inertia-link class="align-items-center text-center" href="/reset-password">
								<i class="fa fa-fw fa-key me-1"></i><span>Change Password</span>
							</inertia-link>
						</div>
					</div>
				</div>
			</div>
		</div>
		<add-beneficiary ref="addBeneficiaryModal" />
		<edit-beneficiary ref="editBeneficiaryModal" />
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

import { onMounted, ref, watch } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { useForm } from '@inertiajs/inertia-vue3'
import AuthLayout from '../../Layouts/AuthLayout'
import AddBeneficiary from '../../Shared/Components/Modals/AddBeneficiary'
import EditBeneficiary from '../../Shared/Components/Modals/EditBeneficiary'

export default {
	layout: AuthLayout,
	props: {
		user: Object,
		flash: Object,
		errors: Object,
		otp_details: Object,
		beneficiaries: Object,
		browserSessions: Object,
		sponsor 			: String,
		countries 			: Object,
		provinces 			: Object,
		cities 				: Object,
	},
	components: {
		AddBeneficiary,
		EditBeneficiary,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const seconds_remain 	= ref(props.otp_details.seconds);
		const minutes 			= ref(0);
		const seconds 			= ref('00');


		const addBeneficiaryModal = ref(null)

		const editBeneficiaryModal = ref(null)

		const tempAvatarUrl = ref(null)

		const formFbLink = useForm({
			c_fblink 	: props.user.c_fblink,
		})

		const form = useForm({
			// fname: props.user.fname,
			// lname: props.user.lname,
			// email: props.user.email,
			gender: props.user.gender,
			address: props.user.address,
			country				: props.user.country??'Philippines',
			province			: props.user.prov_code+'|'+props.user.province??'',
			city				: props.user.city??'',
			bday: props.user.bday,
			mobile: props.user.mobile,
			country_code: props.user.country_code,
			country_calling_code: props.user.country_calling_code,
		})

		const formVerify = useForm({
			mobile_otp : ''
		});

		const toggleModal = (modalType) => {
			if (modalType === 'add') {
				addBeneficiaryModal.value.toggleModal()
			}

			if (modalType === 'edit') {
				editBeneficiaryModal.value.toggleModal()
			}
		}

		const countdown = ()=>{
							if(seconds_remain.value>0)
							{
								seconds_remain.value--;

								minutes.value = parseInt(seconds_remain.value / 60);
								seconds.value = parseInt(seconds_remain.value - (minutes.value*60));
								seconds.value = ((seconds.value).toString()).length<2 ? '0'+seconds.value : seconds.value;

								setTimeout(function(){
									countdown();
								},1000)
							}
						}

		const onFileChange = (e) => {
			const file = e.target.files[0]

			if (file) {
				Inertia.post(
					route('post.change-avatar'),
					{ avatar: file },
					{
						forceFormData: true,
						preserveScroll: true,
						onSuccess: () => {
							document.getElementById('avatar').value = null
						},
					}
				)
			}
		}

		const onInput = (number, phoneObject) => {
			if (phoneObject?.formatted) {
				form.mobile 				= phoneObject.number;
				form.country_calling_code 	= phoneObject.countryCallingCode;
			}
		}

		const onCountryChange = (countryObject) => {
			form.country_code = countryObject.iso2
		}

		// watch(
		// 	() => form.gender,
		// 	(gender) => {
		// 		Inertia.post(
		// 			route('post.update-gender'),
		// 			{ gender: gender },
		// 			{
		// 				preserveState: true,
		// 				preserveScroll: true,
		// 			}
		// 		)
		// 	}
		// )

		const updateProfile = ()=>{
									form.put("profile",{
										preserveState: true,
										preserveScroll: true,
										only:['user,flash']
									});
								}

		const updateFbProfileLink = ()=>{
										formFbLink.put("profile/facebook",{
											preserveState: true,
											preserveScroll: true,
											only:['user,flash']
										});
									}

		const updateMobile = ()=>{
								form.put("profile/mobile",{
									preserveState: true,
									preserveScroll: true,
									only:['user,flash']
								});
							}

		// watch(
		// 	() => form.bday,
		// 	(bday) => {
		// 		Inertia.post(
		// 			route('post.update-bday'),
		// 			{ bday: bday },
		// 			{
		// 				preserveState: true,
		// 				preserveScroll: true,
		// 			}
		// 		)
		// 	}
		// )

		return {
			form,
			formFbLink,
			toggleModal,
			onFileChange,
			tempAvatarUrl,
			seconds_remain,
			minutes,
			seconds,
			countdown,
			formVerify,
			addBeneficiaryModal,
			editBeneficiaryModal,
			onInput,
			onCountryChange,
			updateProfile,
			updateFbProfileLink,
			updateMobile
		}
	},
}
</script>
